<div id="container">
  <div class="custom-header custom-padding">
    <div class="">
      <img class="cursor" (click)="navigateToHomePage()" src={{AVEVALogoURL}} />
    </div>
  </div>
  <div class=" main-container custom-padding">
    <router-outlet></router-outlet>
  </div>
  <footer id="footer" class="gcs-footer-container">
    <div class="footer-container">
      <div class="row verticalAlign-m">
        <div class="col-lg-12 col-md-12  col-sm-12 col-xs-12 center-align-md center-align-sm center-align-xs gcs-footer-text-center gcs-text-color pad-0">
          <p class="pull-left m-t-5">&copy; {{year|date:'yyyy'}} AVEVA Group Limited and its subsidiaries. All rights reserved.</p>
          <img class="gcs-footer-img cursor" src="{{AVEVALogoAltURL}}" alt="AVEVA Logo" (click)="navigateToHomePage()" />
          <ul class="gcs-footer-links">
            <li><a target="_blank" href="https://www.aveva.com/en/Terms_of_Use/">Terms of Use</a></li>                    |
            <li><a target="_blank" href="https://www.aveva.com/en/Privacy_Policy">Privacy Policy</a></li>
          </ul>

        </div>

      </div>
    </div>
  </footer>
</div>
